import callApi from '../../utils/api';
import { API_BASE_URL } from '../../utils/constants';

const api = callApi(API_BASE_URL || '');

export const GET_STUDENT_TEST_SCORES = (studentId) =>
    `/v1/api/scoring/students/${encodeURIComponent(studentId)}/tests`;
export const GET_ATTEMPT_HISTORY = (studentId, assessmentId) =>
    `/v1/api/scoring/students/${encodeURIComponent(studentId)}/tests/${encodeURIComponent(assessmentId)}/attempts`;
export const GET_STUDENT_CHAPTER_SCORES = (studentId) =>
    `/v1/api/scoring/students/${encodeURIComponent(studentId)}/chapters`;
export const GET_CHAPTER_ATTEMPT_HISTORY = (studentId, chapterId) =>
    `/v1/api/scoring/students/${encodeURIComponent(studentId)}/chapters/${encodeURIComponent(chapterId)}/attempts`;
export const GET_ASSESSMENT_SUMMARY = (studentId, courseId) =>
    `/v1/api/scoring/students/${encodeURIComponent(studentId)}/courses/${encodeURIComponent(courseId)}/assessment-summary`;
export const GET_STRENGTHS_WEAKNESSES = (studentId, courseId) =>
    `/v1/api/scoring/students/${encodeURIComponent(studentId)}/courses/${encodeURIComponent(courseId)}/strengths-weaknesses`;

export const getStudentTestScoresApi = async (studentId) =>
    api.get(GET_STUDENT_TEST_SCORES(studentId));

export const getAttemptHistoryApi = async (studentId, assessmentId) =>
    api.get(GET_ATTEMPT_HISTORY(studentId, assessmentId));

export const getStudentChapterScoresApi = async (studentId) =>
    api.get(GET_STUDENT_CHAPTER_SCORES(studentId));

export const getChapterAttemptHistoryApi = async (studentId, chapterId) =>
    api.get(GET_CHAPTER_ATTEMPT_HISTORY(studentId, chapterId));

export const getAssessmentSummaryApi = async (studentId, courseId) =>
    api.get(GET_ASSESSMENT_SUMMARY(studentId, courseId));

export const getStrengthsWeaknessesApi = async (studentId, courseId) =>
    api.get(GET_STRENGTHS_WEAKNESSES(studentId, courseId));
